import React, { useState, useEffect, useContext } from 'react'
import { IntlProvider } from 'react-intl'
import localEN from '../intl/en.json'
import localDE from '../intl/de.json'
import localES from '../intl/es.json'
import { LangContext, LangProvider } from '../context/LanguageContext'
import { FirebaseContext, useAuth } from './Firebase'

import './all.scss'
import './datepicker.css'
import 'react-swipeable-list/dist/styles.css'
import './timePicker.css'
import 'small-tooltip/smallTooltip.css'
import "@pdfslick/react/dist/pdf_viewer.css"

import OfflineOnlineIndication from './OfflineOnlineIndication'
import SmallTooltip from 'small-tooltip'

// if (typeof window !== 'undefined') {
//   const smallTooltip = new SmallTooltip()
//   smallTooltip.init()
//   if (!localStorage.getItem('lang')) {
//     localStorage.setItem('lang', 'en')
//   }
// }


const LayoutInner = ({ children }) => {
  const { lang } = useContext(LangContext)
  const { user, firebase, loading } = useAuth()

  const [language, setLanguage] = useState(localEN)

  useEffect(() => {
    const smallTooltip = new SmallTooltip()
    smallTooltip.init()

    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'en')
    }
  }, [])

  useEffect(() => {
    switch (lang) {
      case 'en': setLanguage(localEN); break
      case 'de': setLanguage(localDE); break
      case 'es': setLanguage(localES); break
      default: setLanguage(localEN); break
    }
  }, [lang])

  return (
    <FirebaseContext.Provider value={{ user, firebase, loading }}>
      <IntlProvider locale={lang} messages={language}>
        <div lang={lang}>
          <div id="small-tooltip"></div>

          <svg viewBox="0 0 0 0" style={{ position: 'absolute', zIndex: '-1', opacity: '0' }}>
            <defs>
              <linearGradient id="boxGradientGrey" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="25" y2="25">
                <stop offset="0%" stopColor="#dde0e6"></stop>
                <stop offset="100%" stopColor="#dde0e6"></stop>
              </linearGradient>

              <linearGradient id="boxGradient" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="25" y2="25">
                <stop offset="0%" stopColor="hsl(141, 71%, 48%)"></stop>
                <stop offset="100%" stopColor="hsl(141, 71%, 48%)"></stop>
              </linearGradient>
              <path id="checkbox__check" stroke="url(#boxGradient)" d="M10 13l2 2 5-5"></path>
              <path id="checkbox__box" stroke="url(#boxGradientGrey)" d="M21 12.7v5c0 1.3-1 2.3-2.3 2.3H8.3C7 20 6 19 6 17.7V7.3C6 6 7 5 8.3 5h10.4C20 5 21 6 21 7.3v5.4"></path>
              <path id="checkbox__box__done" stroke="url(#boxGradient)" d="M21 12.7v5c0 1.3-1 2.3-2.3 2.3H8.3C7 20 6 19 6 17.7V7.3C6 6 7 5 8.3 5h10.4C20 5 21 6 21 7.3v5.4"></path>
              <g id="settings" transform="translate(0,-936.36218)"><path d="m 43.999998,959.36216 -3,10.43754 c -2.71536,0.748 -5.26077,1.8245 -7.65625,3.1875 l -9.5,-5.2813 -8.5,8.5 5.28125,9.5 c -1.36295,2.3955 -2.43943,4.9409 -3.1875,7.6563 l -10.4375,3 0,12 10.4375,3 c 0.74807,2.7154 1.82455,5.2608 3.1875,7.6562 l -5.28125,9.5 8.5,8.5 9.5,-5.2812 c 2.39548,1.3629 4.94089,2.4394 7.65625,3.1875 l 3,10.4375 12,0 3,-10.4375 c 2.71537,-0.7481 5.26077,-1.8246 7.65625,-3.1875 l 9.500004,5.2812 8.5,-8.5 -5.28125,-9.5 c 1.36294,-2.3954 2.43943,-4.9408 3.1875,-7.6562 l 10.4375,-3 0,-12 -10.4375,-3 c -0.74807,-2.7154 -1.82456,-5.2608 -3.1875,-7.6563 l 5.28125,-9.5 -8.5,-8.5 -9.500004,5.2813 c -2.39548,-1.363 -4.94088,-2.4395 -7.65625,-3.1875 l -3,-10.43754 -12,0 z m 6,23.00004 c 11.0457,0 20,8.9543 20,20 0,11.0457 -8.9543,20 -20,20 -11.0457,0 -20,-8.9543 -20,-20 0,-11.0457 8.9543,-20 20,-20 z" stroke="none" visibility="visible" display="inline" overflow="visible"></path></g>
            </defs>
          </svg>

          <svg viewBox="0 0 0 0" style={{ position: 'absolute', zIndex: '-1', opacity: '0' }}>
            <defs>
            <linearGradient id="boxGradientGrey" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="25" y2="25">
                <stop offset="0%" stopColor="#dde0e6"></stop>
                <stop offset="100%" stopColor="#dde0e6"></stop>
              </linearGradient>

              <linearGradient id="boxGradient" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="25" y2="25">
                <stop offset="0%" stopColor="hsl(141, 71%, 48%)"></stop>
                <stop offset="100%" stopColor="hsl(141, 71%, 48%)"></stop>
              </linearGradient>
              <path id="document-checkbox__check" stroke="url(#boxGradient)" d="M10 13l2 2 5-5"></path>
              <path id="document-checkbox__box" stroke="url(#boxGradientGrey)" d="M21 12.7v5c0 1.3-1 2.3-2.3 2.3H8.3C7 20 6 19 6 17.7V7.3C6 6 7 5 8.3 5h10.4C20 5 21 6 21 7.3v5.4"></path>
              <path id="document-checkbox__box__done" stroke="url(#boxGradient)" d="M21 12.7v5c0 1.3-1 2.3-2.3 2.3H8.3C7 20 6 19 6 17.7V7.3C6 6 7 5 8.3 5h10.4C20 5 21 6 21 7.3v5.4"></path>
              <g id="settings" transform="translate(0,-936.36218)"><path d="m 43.999998,959.36216 -3,10.43754 c -2.71536,0.748 -5.26077,1.8245 -7.65625,3.1875 l -9.5,-5.2813 -8.5,8.5 5.28125,9.5 c -1.36295,2.3955 -2.43943,4.9409 -3.1875,7.6563 l -10.4375,3 0,12 10.4375,3 c 0.74807,2.7154 1.82455,5.2608 3.1875,7.6562 l -5.28125,9.5 8.5,8.5 9.5,-5.2812 c 2.39548,1.3629 4.94089,2.4394 7.65625,3.1875 l 3,10.4375 12,0 3,-10.4375 c 2.71537,-0.7481 5.26077,-1.8246 7.65625,-3.1875 l 9.500004,5.2812 8.5,-8.5 -5.28125,-9.5 c 1.36294,-2.3954 2.43943,-4.9408 3.1875,-7.6562 l 10.4375,-3 0,-12 -10.4375,-3 c -0.74807,-2.7154 -1.82456,-5.2608 -3.1875,-7.6563 l 5.28125,-9.5 -8.5,-8.5 -9.500004,5.2813 c -2.39548,-1.363 -4.94088,-2.4395 -7.65625,-3.1875 l -3,-10.43754 -12,0 z m 6,23.00004 c 11.0457,0 20,8.9543 20,20 0,11.0457 -8.9543,20 -20,20 -11.0457,0 -20,-8.9543 -20,-20 0,-11.0457 8.9543,-20 20,-20 z" stroke="none" visibility="visible" display="inline" overflow="visible"></path></g>
            </defs>
          </svg>

          <div>{children}</div>
          <OfflineOnlineIndication />
        </div>
      </IntlProvider>
    </FirebaseContext.Provider>
  )
}

// Outer wrapper with context
const TemplateWrapper = ({ children }) => {
  return (
    <LangProvider>
      <LayoutInner>{children}</LayoutInner>
    </LangProvider>
  )
}

export default TemplateWrapper
